import styled from 'styled-components';

export const HotelOverviewContainer = styled.div`
  display: flex;
  max-width: 120rem;
  margin: 0 auto 1.2rem;
`;

export const HotelInfoImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

export const OuterWrapperDiv = styled.section(
  props => `
  background-color: ${props.theme.colors.goWhite.base};
`,
);
